<!-- フッターナビ -->
<template>
  <nav
    class="crly-o-common-footer-nav"
    :class="[
      { hidden: isHidden },
      { scrollDown: isScrollDown },
      { searchMenu: showSearchMenu }
    ]"
  >
    <ul>
      <CrlyMoleculesCommonFooterNavItem
        v-for="item in navList"
        :key="item.type"
        :item="item"
        :showSearchMenu="showSearchMenu"
        @clickFooterNavItem="clickFooterNavItem"
      />
    </ul>
    <CrlyOrganismsCommonSearchSlideMenu
      :showSearchMenu="showSearchMenu"
      @clickMenusClose="clickMenusClose"
    />
  </nav>
</template>

<script>
import CrlyMoleculesCommonFooterNavItem from "@crly/components/molecules/common/FooterNavIte.vue";
import CrlyOrganismsCommonSearchSlideMenu from "@crly/components/organisms/common/SearchSlideMenu.vue";

export default {
  name: "CrlyOrganismsCommonFooterNav",
  components: {
    CrlyMoleculesCommonFooterNavItem,
    CrlyOrganismsCommonSearchSlideMenu
  },
  props: {
    /**
     * スライドメニューの表示状態
     */
    showMenu: {
      type: Boolean,
      default: false
    }
  },
  data: function () {
    return {
      /**
       * 検索メニュー表示状態
       */
      showSearchMenu: false,
      navList: [
        {
          type: "search"
        },
        {
          type: "favorite",
          linkName: "CrlyFavorite"
        },
        {
          type: "pass",
          linkName: "MypageMembershipPass"
        },
        {
          type: "myPage",
          linkName: "MyPage"
        }
      ],
      /**
       * 下方向スクロール
       */
      isScrollDown: false,
      setPosition: 0
    };
  },
  mounted() {
    this.setScrollEvent();
  },
  computed: {
    isHidden() {
      console.log("■現在の画面path", this.$route.path);
      let str = this.$route.path;
      // メニュー一覧画面、メニュー詳細画面でなければ非表示
      if ( str.indexOf('/search/menu') === -1 && str.indexOf('/menus') === -1 ) {
        return true;
      }
      return false;
    }
  },
  methods: {
    /**
     * ナビアイテムクリックイベント
     */
    clickFooterNavItem(item) {
      if (item.type === "search") {
        // 検索
        this.showSearchMenu = true;
        this.$emit("clickMenuBtn", true);
      } else if (item.linkName) {
        // お気に入り
        this.$router.push({ name: item.linkName });
      } else if (item.linkBS) {
        // 会員証
        // マイページ
        this.windowOpen(this.CONST_LINK_BS[item.linkBS]);
      }
    },
    /**
     * 検索メニューのクローズイベント
     */
    clickMenusClose() {
      this.$store.commit("menuStatus/setSlideMenu", false);
      this.showSearchMenu = false;
    },
    /**
     * スクロール中のイベント
     */
    scrolling() {
      // スクロールイベントがたくさん発火されるので間引く
      setTimeout(() => {
        if (this.setPosition != document.documentElement.scrollTop) {
          this.$set(
            this,
            "isScrollDown",
            this.setPosition < document.documentElement.scrollTop
          );
        }
        this.setPosition = document.documentElement.scrollTop;
      }, 50);
    },
    setScrollEvent() {
      window.addEventListener("scroll", this.scrolling);
    }
  },
  watch: {
    showMenu: function (val) {
      this.$store.commit("menuStatus/setSlideMenu", val);
      // スライドメニュー表示時は検索メニューを閉じる
      if (val == false) {
        this.showSearchMenu = false;
      }
    }
  }
};
</script>

<style lang="scss" scoped>
@import "@crly/assets/css/organisms/common/footerNav.scss";
</style>
